export enum SvgIconSize {
    small = "16px",
    medium = "20px", // actually 16px, see https://doc.supplyon.de/display/S10071/Iconography -> Dimensions
    large = "28px", // actually 24px, see https://doc.supplyon.de/display/S10071/Iconography -> Dimensions
}
